var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_153_230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_153_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 14.1667C11.0222 14.1667 10.4722 13.9389 10.0167 13.4833C9.56111 13.0278 9.33333 12.4778 9.33333 11.8333C9.33333 11.1889 9.56111 10.6389 10.0167 10.1833C10.4722 9.72778 11.0222 9.5 11.6667 9.5C12.3111 9.5 12.8611 9.72778 13.3167 10.1833C13.7722 10.6389 14 11.1889 14 11.8333C14 12.4778 13.7722 13.0278 13.3167 13.4833C12.8611 13.9389 12.3111 14.1667 11.6667 14.1667ZM11.6667 12.8333C11.9444 12.8333 12.1806 12.7361 12.375 12.5417C12.5694 12.3472 12.6667 12.1111 12.6667 11.8333C12.6667 11.5556 12.5694 11.3194 12.375 11.125C12.1806 10.9306 11.9444 10.8333 11.6667 10.8333C11.3889 10.8333 11.1528 10.9306 10.9583 11.125C10.7639 11.3194 10.6667 11.5556 10.6667 11.8333C10.6667 12.1111 10.7639 12.3472 10.9583 12.5417C11.1528 12.7361 11.3889 12.8333 11.6667 12.8333ZM2 12.5V11.1667H8V12.5H2ZM4.33333 7.5C3.68889 7.5 3.13889 7.27222 2.68333 6.81667C2.22778 6.36111 2 5.81111 2 5.16667C2 4.52222 2.22778 3.97222 2.68333 3.51667C3.13889 3.06111 3.68889 2.83333 4.33333 2.83333C4.97778 2.83333 5.52778 3.06111 5.98333 3.51667C6.43889 3.97222 6.66667 4.52222 6.66667 5.16667C6.66667 5.81111 6.43889 6.36111 5.98333 6.81667C5.52778 7.27222 4.97778 7.5 4.33333 7.5ZM4.33333 6.16667C4.61111 6.16667 4.84722 6.06944 5.04167 5.875C5.23611 5.68055 5.33333 5.44444 5.33333 5.16667C5.33333 4.88889 5.23611 4.65278 5.04167 4.45833C4.84722 4.26389 4.61111 4.16667 4.33333 4.16667C4.05556 4.16667 3.81944 4.26389 3.625 4.45833C3.43056 4.65278 3.33333 4.88889 3.33333 5.16667C3.33333 5.44444 3.43056 5.68055 3.625 5.875C3.81944 6.06944 4.05556 6.16667 4.33333 6.16667ZM8 5.83333V4.5H14V5.83333H8Z",
    fill: "#2F7B8A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-icon.ca95ca958a6691eca4ac0ba031242681.svg";